import React from 'react';
export const Privacy = () => {
  return <div className="py-20 lg:py-24 bg-white min-h-[calc(100vh-300px)]" data-id="element-864">
      <div className="max-w-content mx-auto px-5 sm:px-8 lg:px-12" data-id="element-865">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-866">
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-ink mb-6 leading-tight" data-id="element-867">
            Privacy Policy
          </h1>
          <p className="text-lg text-gray-600" data-id="element-868">
            How we collect, use, and protect your information.
          </p>
        </div>

        <div className="max-w-3xl mx-auto prose prose-lg prose-red text-gray-600" data-id="element-869">
          <p data-id="element-870">Last Updated: January 1, 2026</p>

          <h3 data-id="element-871">Information We Collect</h3>
          <p data-id="element-872">
            We collect information you provide directly to us when you create an
            account, apply for wholesale access, use our online designer, or
            communicate with us. This may include your name, email address,
            phone number, shipping address, and payment information.
          </p>

          <h3 data-id="element-873">How We Use Your Information</h3>
          <p data-id="element-874">
            We use the information we collect to process your orders, provide
            customer support, communicate with you about your account, and
            improve our services. For end-users seeking ordering assistance, we
            may share your contact information and design details with a
            registered dealer to facilitate your order.
          </p>

          <h3 data-id="element-875">Data Security</h3>
          <p data-id="element-876">
            We implement reasonable security measures to protect your personal
            information from unauthorized access, alteration, or disclosure.
            However, no method of transmission over the Internet is 100% secure.
          </p>

          <h3 data-id="element-877">Cookies</h3>
          <p data-id="element-878">
            Our website uses cookies to enhance your browsing experience,
            remember your preferences, and maintain your session while using the
            online designer. You can choose to disable cookies through your
            browser settings, but this may affect site functionality.
          </p>

          <h3 data-id="element-879">Contact Us</h3>
          <p data-id="element-880">
            If you have any questions about this Privacy Policy, please contact
            us at privacy@customuniformsupplier.com.
          </p>
        </div>
      </div>
    </div>;
};